import { createSelector } from '@reduxjs/toolkit'
import { ISummary } from './reducer'

const rootState = (state: ISummary) => state.summary

export const getMonthlyTotal = createSelector(
  rootState,
  (state) => state.monthlyTotal
)

export const getProrateTotal = createSelector(
  rootState,
  (state) => state.prorateTotal
)
